import React from "react";
import Text from "../../../common/text";

import {
  Dialog,
  TextField,
  Select,
  FormHelperText,
  makeStyles,
  MenuItem,
  Modal,
  Backdrop,
  Fade
} from "@material-ui/core";
import { editPayment } from "./../websiteBuilderActions";

import SentroFileField from "../../common/sentroFileField";
import SentroButton from "../../common/sentroButton";
import CloseIcon from "@material-ui/icons/Close";
import { bankListing, paymentMethods } from "./bankContants";
import { useDispatch, useSelector } from "react-redux";
let defaultImg =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUvSURBVHgB7d3Pi9R1HMfxTxE7F9eDsx3KQymYG4QHacFYURoIBA+rgWuQ3brUX6MXu3SrS0cDKQg2DJaCBQ/moQiSDq6X3YvrZfdi+xEGiuzFfHW+88N5PEA8ON9hGebpfHY/n31/X7p67frjAjzVywX4XwKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUyYTmeuMDkEMkGWlk6WKx9/VLrdbmEyCGRC1DiW3j355BPk8urFsrj4VmH8BDIB+nH8U+/9M+XEiXcK4yWQMTu9fOo/cfzr35ZOFsbnlcLY9HpnyuLxvJTqx7OxcbswegIZg/p9xrlzH5TDr7820ONFMj4CGbEax4WV841/UiWS8fA9yAjNzx94pjj6aiS93tnC6PgEGZF+HPPz8+V5LB4/9uTvtbVbhfb5BBmBYcXRVyNZ3d8rsevePoG0bNhx9C3sL9NWnjzvgUJ7BNKibvdQWb10cehx9NVILoikVQJpSY2jvnk7nU5pU41PJO0RSAvqOapRxNEnkvYIZMhqHPUc1aji6BNJOwQyRPVwYY1jXGokq5c+dFx+iOyDDMnTTuQmOzs7pYm5uc5AP9bt79R/9/0PZXPzQeH5CGRI+ht4g1pb+6ncb/AGrvENerK3RvL2/lJPIM/PEgsCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAwlUdN6i8KLZ8+VSZJ01+KWl4+VXb39gZ+/EGndMdiKgOpZ40GnSk1qRYWnLidBpZYEAgEAoFAIBAIBAKBQCAQCAQCgUAgEMzMVJP795tN+Dh8uN2d+q2t7bK72+CoycF5Q+HGYCYC2dl5VG58e7PRNZ9/9mlp0/r6L62N/WF4LLEgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEL129dv1xmTJ1osnKyvlG1zS95Vlb9zbv293dLXsNxv7Mzc01ujFo0+cfha++/qZMm5k5rNj2G76p+mZv8064bT//rLDEgkAgEAgEAoFAIBAIBAKBQCAQCAQCgWAmdtLreJ179/5qdM3i4rHSpj/3v569BmN/Fl7tloXuodKWOvmlyWikevTl6NE3yotuJgKpZ5LWfrzV6Jq2A/n1zt3GY3/aDOThw51Gr1Gd0TULgVhiQSAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCGZm7A/jd/2LL8u08QkCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgmJmxP+vrPze6ptc7W9q0sXG70V2vjhx5c/9Pe1NEtra2y507dwd+fKczV5aX3ysvupkZ+/Pb7380uqbtQDY3HzQa+1PvkNVmIPU/kSavUR37MwuBWGJBIBAIBAKBQCAQCAQCgUAgEAgEAoFAMBM76VXdiZ4k9euZn3808OM7nU5pUz060uQ1Ori/kz4LZiKQeizikyuXyyTp9c6USbKw0J2412gSWGJBIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIpvKoydb2drlx42aBtk1lIHVETZOROfCsLLEgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBD8DcdF1Hbi/9DMAAAAAElFTkSuQmCC";
let payPaylImg =
  "data:image/png;base64,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";
let PaymentFormDialogEdit = props => {
  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`
    };
  }

  const useStyles = makeStyles(theme => ({
    paper: {
      position: "absolute",
      backgroundColor: "#fff",
      borderRadius: 4
    },
    btnSave: {
      width: 80,
      margin: 5,
      boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
      "&:hover": { backgroundColor: "#DD5e56" }
    },
    btnCancel: {
      width: 80,
      margin: 5,
      "&:hover": { border: "1px solid #F97663" }
    }
  }));

  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [loading, setLoading] = React.useState("");

  function cutMobileNumber(value) {
    let cut = value.slice(0, 11);
    return cut.replace(/[^0-9]/g, "");
  }

  function onCloseDialog() {
    props.setOpenDialogEdit(false);
    props.setPaymentMethod({
      user: paymentMethod.user,
      store: STORE_UUID,
      payment_method: "Bank",
      qr_code_img: "",
      bank_name: "UnionBank of the Philippines",
      account_name: "",
      account_number: "",
      email: "no@pics.com",
      payment_link: "",
      mobile_number: ""
    });
  }

  function validURL(str) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(str);
  }

  function createPreview(file) {
    if (validURL(file)) {
      return file;
    } else {
      var blob = new Blob([file], { type: file.type });
      var blobUrl = URL.createObjectURL(blob);

      var xhr = new XMLHttpRequest();
      xhr.responseType = "blob";

      xhr.onload = function() {
        var recoveredBlob = xhr.response;

        var reader = new FileReader();

        reader.onload = function() {
          var blobAsDataUrl = reader.result;
          window.location = blobAsDataUrl;
        };

        reader.readAsDataURL(recoveredBlob);
      };

      return blobUrl;
    }
  }
  const dispatch = useDispatch();
  let forEdit = useSelector(state => state.webBuilder.paymentDetails);

  React.useEffect(() => {
    Object.keys(forEdit).map(item => {
      console.log(item);
      if (item == "qr_code_img") {
        setPaymentValue("qr_code_img", defaultImg);
      } else {
        console.log(item, "none_img");
        setPaymentValue(item, forEdit[item]);
      }
    });
  }, []);

  let [error, setError] = React.useState({ disabled: true });

  function setPaymentValue(key, value) {
    if (key == "email") {
      if (!value || value == "") {
        setError(prevState => ({
          ...prevState,
          email: "This field is required",
          disabled: true
        }));
      } else {
        setError(prevState => ({
          ...prevState,
          email: "",
          disabled: false
        }));
      }
    } else if (key == "account_number") {
      if (!value || value == "") {
        setError(prevState => ({
          ...prevState,
          account_number: "This field is required",
          disabled: true
        }));
      } else if (isNaN(value)) {
        setError(prevState => ({
          ...prevState,
          account_number: "Account number must be numerical",
          disabled: true
        }));
      } else {
        setError(prevState => ({
          ...prevState,
          account_number: "",
          disabled: false
        }));
      }
    } else if (key == "account_name") {
      if (!value || value == "") {
        setError(prevState => ({
          ...prevState,
          account_name: "This field is required",
          disabled: true
        }));
      } else {
        setError(prevState => ({
          ...prevState,
          account_name: "",
          disabled: false
        }));
      }
    } else if (key == "mobile_number") {
      if (!value || value == "") {
        setError(prevState => ({
          ...prevState,
          mobile_number: "This field is required",
          disabled: true
        }));
      } else if (isNaN(value)) {
        setError(prevState => ({
          ...prevState,
          mobile_number: "This is an invalid mobile number",
          disabled: true
        }));
      } else if (value.charAt(0) != 0) {
        setError(prevState => ({
          ...prevState,
          mobile_number: "This is an invalid mobile number",
          disabled: true
        }));
      } else if (value.charAt(1) != 9) {
        setError(prevState => ({
          ...prevState,
          mobile_number: "This is an invalid mobile number",
          disabled: true
        }));
      } else if (value.length > 11) {
        props.setPaymentMethod(prevState => ({
          ...prevState,
          mobile_number: value.toString().slice(0, 11)
        }));
      } else {
        setError(prevState => ({
          ...prevState,
          mobile_number: "",
          disabled: false
        }));
      }
    } else if (key == "payment_link") {
      if (!value || value == "") {
        setError(prevState => ({
          ...prevState,
          payment_link: "This field is required",
          disabled: true
        }));
      } else {
        setError(prevState => ({
          ...prevState,
          payment_link: "",
          disabled: false
        }));
      }
    } else {
      setError({});
    }
    props.setPaymentMethod(prevState => ({
      ...prevState,
      [key]: value
    }));
  }

  let STORE_UUID = localStorage.getItem("STORE_UUID");

  const { paymentMethod } = props;
  function submitPaymentMethod() {
    let payment = {
      user: forEdit.user,
      store: STORE_UUID,
      payment_method: paymentMethod.payment_method,
      qr_code_img:
        paymentMethod.payment_method == "PayPal"
          ? payPaylImg
          : paymentMethod.qr_code_img,
      bank_name: paymentMethod.bank_name,
      account_name: paymentMethod.account_name,
      account_number: paymentMethod.account_number,
      email:
        paymentMethod.qr_code_img == defaultImg
          ? "no@pics.com"
          : paymentMethod.email,

      payment_link: paymentMethod.payment_link,
      mobile_number: paymentMethod.mobile_number,
      uuid: paymentMethod.uuid
    };
    dispatch(editPayment(payment));
    onCloseDialog();
  }

  return (
    <div>
      <Modal
        open={props.openDialog}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={props.openDialog}>
          <div style={modalStyle} className={classes.paper}>
            <div style={{ padding: "25px 50px 25px 50px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Text
                  textType="h3"
                  content={"Your Other Payment Channels"}
                  style={{ color: "#1E4B83" }}
                />
                <div
                  onClick={() => {
                    onCloseDialog();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <CloseIcon />
                </div>
              </div>
              <div style={{ marginTop: 20, display: "flex" }}>
                <div style={{ width: 400, marginRight: 50 }}>
                  <div style={{ width: "100%", marginTop: "2vh" }}>
                    <div style={{ display: "flex" }}>
                      <Text textType="p1_Semibold" content="Payment Method" />
                      <span style={{ color: "#c24a39", marginLeft: 2 }}>*</span>
                    </div>
                    <Select
                      id="payment_method"
                      onChange={e =>
                        setPaymentValue("payment_method", e.target.value)
                      }
                      disabled={true}
                      value={paymentMethod.payment_method}
                      variant="outlined"
                      fullWidth
                      placeholder="Bank"
                    >
                      {paymentMethods.map((item, key) => {
                        return <MenuItem value={item}>{item}</MenuItem>;
                      })}
                    </Select>
                  </div>
                  {paymentMethod.payment_method != "PayPal" ? (
                    <div style={{ width: "100%", marginTop: 10 }}>
                      <Text textType="p1_Semibold" content="QR Code" />
                      <SentroFileField
                        name="qr_code_img"
                        loading={loading}
                        preview={
                          paymentMethod.qr_code_img
                            ? createPreview(paymentMethod.qr_code_img)
                            : null
                        }
                        onChange={value =>
                          setPaymentValue("qr_code_img", value)
                        }
                      />
                    </div>
                  ) : (
                    <div>
                      {/* <div style={{ width: "100%", marginTop: 10 }}>
                    <Text textType="p1_Semibold" content="Email" />
                    <TextField
                      value={paymentMethod.email}
                      error={error && error.email}
                      color="secondary"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setPaymentValue("email", e.target.value)}
                    />
                    <FormHelperText error id="component-error-text">
                      {error && error.email}
                    </FormHelperText>
                  </div> */}
                      <div style={{ width: "100%", marginTop: 10 }}>
                        <div style={{ display: "flex" }}>
                          <Text textType="p1_Semibold" content="Payment Link" />
                          <span style={{ color: "#c24a39", marginLeft: 2 }}>
                            *
                          </span>
                        </div>
                        <TextField
                          id="payment_link"
                          error={error && error.payment_link}
                          value={paymentMethod.payment_link}
                          color="secondary"
                          onChange={e =>
                            setPaymentValue("payment_link", e.target.value)
                          }
                          fullWidth
                          variant="outlined"
                        />
                        <FormHelperText error id="component-error-text">
                          {error && error.payment_link}
                        </FormHelperText>
                      </div>
                    </div>
                  )}
                </div>
                {// paymentMethod.payment_method == "PayPal" ? (
                //   <div style={{ width: 400 }} />
                // ) :
                paymentMethod.payment_method == "Bank" ? (
                  <div style={{ width: 400 }}>
                    <div style={{ width: "100%", marginTop: 10 }}>
                      <div style={{ display: "flex" }}>
                        <Text textType="p1_Semibold" content="Bank Name" />
                        <span style={{ color: "#c24a39", marginLeft: 2 }}>
                          *
                        </span>
                      </div>
                      <Select
                        id="bank_name"
                        disabled={true}
                        value={paymentMethod.bank_name}
                        variant="outlined"
                        error={error && error.bank_name}
                        onChange={e =>
                          setPaymentValue("bank_name", e.target.value)
                        }
                        fullWidth
                        placeholder="Bank"
                      >
                        {bankListing.map((item, key) => {
                          return (
                            <MenuItem value={item.name}>{item.name}</MenuItem>
                          );
                        })}
                      </Select>
                    </div>

                    <div style={{ width: "100%", marginTop: 10 }}>
                      <div style={{ display: "flex" }}>
                        <Text textType="p1_Semibold" content="Account Name" />
                        <span style={{ color: "#c24a39", marginLeft: 2 }}>
                          *
                        </span>
                      </div>
                      <TextField
                        id="account_name"
                        color="secondary"
                        fullWidth
                        value={paymentMethod.account_name}
                        error={error && error.account_name}
                        variant="outlined"
                        onChange={e =>
                          setPaymentValue("account_name", e.target.value)
                        }
                      />
                      <FormHelperText error id="component-error-text">
                        {error && error.account_name}
                      </FormHelperText>
                    </div>
                    <div style={{ width: "100%", marginTop: 10 }}>
                      <div style={{ display: "flex" }}>
                        <Text textType="p1_Semibold" content="Account Number" />
                        <span style={{ color: "#c24a39", marginLeft: 2 }}>
                          *
                        </span>
                      </div>
                      <TextField
                        id="account_number"
                        value={paymentMethod.account_number}
                        color="secondary"
                        error={error && error.account_number}
                        fullWidth
                        variant="outlined"
                        onChange={e =>
                          setPaymentValue("account_number", e.target.value)
                        }
                      />
                      <FormHelperText error id="component-error-text">
                        {error && error.account_number}
                      </FormHelperText>
                    </div>
                  </div>
                ) : paymentMethod.payment_method == "PayPal" ? (
                  <div style={{ width: 400 }} />
                ) : (
                  <div style={{ width: 400 }}>
                    <div style={{ width: "100%", marginTop: 10 }}>
                      <div style={{ display: "flex" }}>
                        <Text textType="p1_Semibold" content="Mobile Number" />
                        <span style={{ color: "#c24a39", marginLeft: 2 }}>
                          *
                        </span>
                      </div>
                      <TextField
                        id="mobile_number"
                        // InputProps={{
                        //   startAdornment: (
                        //     <InputAdornment position="end">
                        //       <Typography
                        //         style={{
                        //           fontWeight: 600,
                        //           color: "rgba(0, 0, 0, 0.54)",
                        //           paddingRight: "8px",
                        //         }}
                        //       >
                        //         +63
                        //       </Typography>
                        //     </InputAdornment>
                        //   ),
                        // }}
                        color="secondary"
                        fullWidth
                        value={paymentMethod.mobile_number}
                        error={error && error.mobile_number}
                        variant="outlined"
                        onChange={e => {
                          setPaymentValue(
                            "mobile_number",
                            cutMobileNumber(e.target.value)
                          );
                          if (e.target.value.length < 11) {
                            setError(prevState => ({
                              ...prevState,
                              mobile_number:
                                "Please enter a valid 11-digit mobile number",
                              disabled: true
                            }));
                          }
                        }}
                        onBlur={e => {
                          if (e.target.value.length < 11) {
                            setError(prevState => ({
                              ...prevState,
                              mobile_number:
                                "Please enter a valid 11-digit mobile number",
                              disabled: true
                            }));
                          }
                        }}
                      />
                      <FormHelperText error id="component-error-text">
                        {error && error.mobile_number}
                      </FormHelperText>
                    </div>
                  </div>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <SentroButton
                  id="cancel_button"
                  style={{ marginTop: 0, padding: 0 }}
                  className={classes.btnCancel}
                  onClick={() => onCloseDialog()}
                  label="Cancel"
                />
                <SentroButton
                  id="save_button"
                  style={{ marginTop: 0, padding: 0 }}
                  className={classes.btnSave}
                  disabled={error.disabled}
                  label="Save"
                  variant="contained"
                  onClick={() => submitPaymentMethod()}
                />
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};
export default PaymentFormDialogEdit;
